import React from 'react'
import { Navigate } from 'react-router-dom'


//test de présence du jeton
const isLogin = () => {
    if  (localStorage.getItem('email')) {
        const authValid = new Date(localStorage.getItem('date_expired'))
        const maintenant = new Date()
        if (authValid > maintenant){
            return true
        }
    }
    return  false
}

//route privé : si je suis logué, je vais vers le composant demandé, sinon je vais vers la page d'authentification
const PrivateRoute = ({ children }) => {
    return ( isLogin() ? children : <Navigate to="/login" /> )
}
export default PrivateRoute